export const EPROMOTION = `EPROMOTION`;

/* LAYOUT */

// DETAIL
export const GET_LIST_OF_VALUE_DATA = `${EPROMOTION}/GET_LIST_OF_VALUE_DATA`;
export const SET_LIST_OF_VALUE_DATA = `${EPROMOTION}/SET_LIST_OF_VALUE_DATA`;

export const SET_CONFIG_FILTER = `${EPROMOTION}/SET_CONFIG_FILTER`;
export const SET_AD_CONFIG_FILTER = `${EPROMOTION}/SET_AD_CONFIG_FILTER`;
export const SET_AOS_CONFIG_FILTER = `${EPROMOTION}/SET_AOS_CONFIG_FILTER`;

export const GET_STATUS_DATA = `${EPROMOTION}/GET_STATUS_DATA`;
export const SET_STATUS_DATA = `${EPROMOTION}/SET_STATUS_DATA`;

export const REGISTER_BY_RECRUITER_REQUEST = `${EPROMOTION}/REGISTER_BY_RECRUITER_REQUEST`;
export const REGISTER_BY_RECRUITER_SUCCESS = `${EPROMOTION}/REGISTER_BY_RECRUITER_SUCCESS`;

export const CHECK_DUPLICATED_PHONE_REQUEST = `${EPROMOTION}/CHECK_DUPLICATED_PHONE_REQUEST`;
export const CHECK_DUPLICATED_PHONE_SUCCESS = `${EPROMOTION}/CHECK_DUPLICATED_PHONE_SUCCESS`;

export const CREATE_POST_PRESIGNED_REQUEST = `${EPROMOTION}/CREATE_POST_PRESIGNED_REQUEST`;
export const CREATE_POST_PRESIGNED_SUCCESS = `${EPROMOTION}/CREATE_POST_PRESIGNED_SUCCESS`;

export const GET_TRACKING_REQUEST = `${EPROMOTION}/GET_TRACKING_REQUEST`;
export const GET_TRACKING_SUCCESS = `${EPROMOTION}/GET_TRACKING_SUCCESS`;

export const UPDATE_BY_PRE_CANDIDATE_REQUEST = `${EPROMOTION}/UPDATE_BY_PRE_CANDIDATE_REQUEST`;
export const UPDATE_BY_PRE_CANDIDATE_SUCCESS = `${EPROMOTION}/UPDATE_BY_PRE_CANDIDATE_SUCCESS`;

export const GET_ERE_DETAIL_REQUEST = `${EPROMOTION}/GET_ERE_DETAIL_REQUEST`;
export const GET_ERE_DETAIL_SUCCESS = `${EPROMOTION}/GET_ERE_DETAIL_SUCCESS`;

// DETAIL
export const GET_PRE_CANDIDATE_DETAIL_DATA = `${EPROMOTION}/GET_PRE_CANDIDATE_DETAIL_DATA`;
export const SET_PRE_CANDIDATE_DETAIL_DATA = `${EPROMOTION}/SET_PRE_CANDIDATE_DETAIL_DATA`;

export const GET_EAPP_PROCESS_HISTORY_DATA = `${EPROMOTION}/GET_EAPP_PROCESS_HISTORY_DATA`;
export const SET_EAPP_PROCESS_HISTORY_DATA = `${EPROMOTION}/SET_EAPP_PROCESS_HISTORY_DATA`;

export const GET_DOC_BUFFERED_DATA = `${EPROMOTION}/GET_DOC_BUFFERED_DATA`;

export const CANDIDATE_CANCEL_E_APP_REQUEST = `${EPROMOTION}/CANDIDATE_CANCEL_E_APP_REQUEST`;

export const UPDATE_BY_AM_REQUEST = `${EPROMOTION}/UPDATE_BY_AM_REQUEST`;

export const SAVE_BY_RECRUITER_REQUEST = `${EPROMOTION}/SAVE_BY_RECRUITER_REQUEST`;

export const RECRUITER_CANCEL_E_APP_REQUEST = `${EPROMOTION}/RECRUITER_CANCEL_E_APP_REQUEST`;

export const DOWNLOAD_BY_CANDIDATE_REQUEST = `${EPROMOTION}/DOWNLOAD_BY_CANDIDATE_REQUEST`;

export const SET_EPROMOTION_AM_CANDIDATE_ID = `${EPROMOTION}/SET_EPROMOTION_PRE_CANDIDATE_ID`;
